export const projects = [
  {
    title: "MusicLab",
    type:"portfolio",
    slug:"musiclab",
    description:"Pulser is the best mobile-focused construction tool for contractors, superintendents and subcontractors who work on building projects.",
    developers:[
      {
        role:"Architector",
        name:"Alexey Postnikov",
      },
      {
        role:"Dev",
        name:"Oles Rubinovsky",
      }
    ],
    mainImage:"/projects_images/music_lab.png",
    gallery:[
      "/projects_images/music_lab/1.png",
      "/projects_images/music_lab/2.png",
      "/projects_images/music_lab/3.png"
    ],
    body:`<p>Pulser is the best mobile-focused construction tool for contractors,
      superintendents and subcontractors who work on building projects.
      It is the first platform for foreman and field workers that provides a modern social media collaboration experience
      in the building site. Pulser simply takes ongoing update posts and turns them into action items to revolutionize the
      field task management process.</p><p>&nbsp;</p><p><strong>Scope</strong></p>
      <p>Mobile app for Android and iOS with back-end and features:</p>
      <ul><li>Sign-up/Sign-in by phone number and SMS-confirmation</li>
      <li>Address Book integration</li>
      <li>Offline mode</li>
      <li>Multi-language (English and Hebrew)</li>
      <li>Push notifications</li>
      <li>Counter (fresh messages) notifications</li>
      <li>Annotations/sketching on images</li>
      <li>Filestorage with file upload from device and internet services</li>
      <li>Invitations for contacts from phone address book by SMS</li>
      <li>Avatars for users</li>
      <li>Realtime updates screen refreshment</li>
      <li>PDF generation</li>
      </ul><p>&nbsp;</p>
      <p><strong>Tech stack</strong></p>
      <p>Front-end: ReactNative and Redux + Bugsnag for QA</p>
      <p>Back-end: Node.js, Google Firebase, Auth0, Twilio, Gulp, Heroku, FastLane/TestFlight</p>`,
    timeDays:"25",
    timeHours:"200",
    url:"https://floating-beyond-10334.herokuapp.com/#/",
  },
  {
    title:"Pulser",
    type: "mobile",
    slug: "pulser",
    description:"Pulser is the best mobile-focused construction tool for contractors, superintendents and subcontractors who work on building projects.",
    developers:[
      {
        role:"Tech.Lead",
        name:"Vladimir Kartavy"
      },
      {
        role:"Development",
        name:"Timur Isaev"
      }
    ],
    mainImage:"/projects_images/pulser_bg.jpg",
    gallery:[
      '/projects_images/pulser/sm1.jpg',
      '/projects_images/pulser/sm2.jpg',
      '/projects_images/pulser/sm3.jpg'
    ],
    timeDays:"120",
    timeHours:"1000",
    url:"http://www.pulser.co",
    body: `<div class="block">Pulser is the best mobile-focused construction tool for contractors, superintendents and subcontractors who work on building projects. 
                It is the first platform for foreman and field workers that provides a modern social media collaboration experience in the building site. 
                Pulser simply takes ongoing update posts and turns them into action items to revolutionize the field task management process.</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with back-end and features:</div>
                <ul>
                    <li>Sign-up/Sign-in by phone number and SMS-confirmation
                    <li>Address Book integration
                    <li>Offline mode
                    <li>Multi-language (English and Hebrew)
                    <li>Push notifications
                    <li>Counter (fresh messages) notifications
                    <li>Annotations/sketching on images
                    <li>Filestorage with file upload from device and internet services
                    <li>Invitations for contacts from phone address book by SMS
                    <li>Avatars for users
                    <li>Realtime updates screen refreshment
                    <li>PDF generation
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Twilio, Gulp, Heroku, FastLane/TestFlight
                </div>`,
    android:"",
    ios:"",
  },
  {
    title:"Beautiful\nTerengganu",
    type: "mobile",
    slug: "terengganu",
    description:"Content-marketing mobile APP featuring resorts and other touristic information about Terengganu state, Malaysia.",
    developers:[
      {role:"CTO", name:"Vladimir Kartavy"},
      {role:"Dev", name:"Timur Isaev"}
    ],
    mainImage:"/projects_images/terengganu_bg.jpg",
    gallery: ['/projects_images/terengganu/sm1.jpg', '/projects_images/terengganu/sm2.jpg', '/projects_images/terengganu/sm3.jpg'],
    timeDays:"15",
    timeHours:"250",
    url:"http://beautifulterengganu.com",
    body: `<div class="block">Content-marketing mobile APP featuring resorts and other touristic information about Terengganu state, Malaysia</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with CMS integration on the back-end:</div>
                <ul>
                    <li>All the graphic/text content managed through Admin Website
                    <li>Offline mode with auto-sync local/remote content
                    <li>Multi-language
                    <li>Sharing to social networks (FB, Twitter, Instagram) 
                    <li>Push notifications
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Twilio, Gulp, Heroku, FastLane/TestFlight
                </div>`,
    android:"https://play.google.com/store/projects_images/details?id=com.pulser.android",
    ios:"https://itunes.apple.com/us/app/pulser-field-construction/id1224626487",
  },
  {
    title:"Iwonado",
    type: "mobile",
    slug: "iwonado",
    description:"Iwonado is a communication directory service application that connects independent service professionals with individuals. We are not an agency, rather we are an introduction service that helps individuals find a professional. And if you are a professional we help you to build a client base.",
    developers:[{role:"CTO", name:"Vladimir Kartavy"}, {role:"Dev", name:"Timur Isaev"}],
    mainImage:"/projects_images/iwonado_bg.jpg",
    gallery: ['/projects_images/iwonado/sm1.jpg', '/projects_images/iwonado/sm2.jpg', '/projects_images/iwonado/sm3.jpg'],
    timeDays:"50",
    timeHours:"420",
    url:"http://iwonado.co.uk",
    body: `<div class="block">Iwonado is a communication directory service application that connects independent service professionals with individuals. We are not an agency, rather we are an introduction service that helps individuals find a professional. And if you are a professional we help you to build a client base.</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with back-end which allows Users to:</div>
                <ul>
                    <li>Signup/Signin with Facebook
                    <li>Professional profile (Driver, Photographer, Cleaner, DJ, Manicure, Masseur)
                    <li>Client profile to request services
                    <li>Geolocation & calendar match-making 
                    <li>Bidding process (Client review and accept offers from Professionals)
                    <li>Reminders and feedback/rating features
                    <li>Push notifications
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Parse, FastLane/TestFlight
                </div>`,
    android:"https://play.google.com/store/projects_images/details?id=com.iwonado",
    ios:"https://appetize.io/embed/pxgbwt9920n21jm5dextac76a4",
  },
  {
    title:"Fin.Do",
    type: "mobile",
    slug: "findo",
    description:"Fin.Do - Instant and safe card2card money transfers mobile App.",
    developers:[{role:"CTO", name:"Vladimir Kartavy"}, {role:"Dev", name:"Timur Isaev"}],
    mainImage:"/projects_images/findo_bg2.jpg",
    gallery: ['/projects_images/findo/sm1.jpg', '/projects_images/findo/sm2.jpg', '/projects_images/findo/sm3.jpg'],
    timeDays:"50",
    timeHours:"420",
    url:"http://fin.do",
    body: `<div class="block">Iwonado is a communication directory service application that connects independent service professionals with individuals. We are not an agency, rather we are an introduction service that helps individuals find a professional. And if you are a professional we help you to build a client base.</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with 3rd-party API integrations:</div>
                <ul>
                    <li>Sign-up/Sign-in by phone number and SMS-confirmation
                    <li>Scan card using www.card.io 
                    <li>Send/Receive money using Address Book and email
                    <li>Send/Receive money using Address Book and phone number 
                    <li>Transaction History by Card/Recipient
                    <li>TouchID and Passcode
                    <li>Push notifications
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Parse, FastLane/TestFlight
                </div>`,
    android:"",
    ios:"https://itunes.apple.com/us/app/fin-do/id1187248755",
  },
  {
    title:"Nebeus",
    type: "mobile",
    slug: "nebeus",
    description:"Monitor your bitcoin accounts, pay, trade, request and offer bitcoin loans easily.",
    developers:[{role:"CTO", name:"Vladimir Kartavy"}, {role:"Dev", name:"Timur Isaev"}],
    mainImage:"/projects_images/nebeus_bg.jpg",
    gallery: ['/projects_images/nebeus/sm1.jpg', '/projects_images/findo/sm2.jpg', '/projects_images/nebeus/sm3.jpg'],
    timeDays:"50",
    timeHours:"420",
    url:"http://nebeus.com",
    body: `<div class="block">Iwonado is a communication directory service application that connects independent service professionals with individuals. We are not an agency, rather we are an introduction service that helps individuals find a professional. And if you are a professional we help you to build a client base.</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with back-end API integration</div>
                <ul>
                    <li>Sing-up/Sign-in with phone number and SMS-verification
                    <li>Manage Accounts/Wallets
                    <li>Manage Loans
                    <li>Exchange 
                    <li>Transaction History
                    <li>Push notifications
                    <li>Integration with Bitcoin blockchain on the back-end
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Parse, FastLane/TestFlight
                </div>`,
    android:"",
    ios:"https://play.google.com/store/projects_images/details?id=com.nebeus.nebeus2",
  },
  {
    title:"iTravel",
    type: "mobile",
    slug: "itravel",
    description:"Search shortest route between two points, verify your location by photo taken from app, play route video",
    developers:[{role:"CTO", name:"Vladimir Kartavy"}, {role:"Dev", name:"Timur Isaev"}],
    mainImage:"/projects_images/itravel_bg.jpg",
    gallery: ['/projects_images/itravel/sm1.jpg', '/projects_images/itravel/sm2.jpg', '/projects_images/itravel/sm3.jpg'],
    timeDays:"50",
    timeHours:"420",
    url:"https://www.traveltimeplatform.com/",
    body: `<div class="block">Search shortest route between two points, verify your location by photo taken from app, play route video</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with 3rd-party API integrations</div>
                <ul>
                    <li>Get nearest POI
                    <li>Calculate route
                    <li>View route on map by parts
                    <li>Send photo to get your location and where are you facing
                    <li>View video for selected route
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Parse, FastLane/TestFlight
                </div>`,
    android:"",
    ios:"https://play.google.com/store/projects_images/details?id=com.nebeus.nebeus2",
  },
  {
    title:"Woopra",
    type: "mobile",
    slug: "woopra",
    description:"View your website recorded data in mobile app using data grids and charts",
    developers:[{role:"CTO", name:"Vladimir Kartavy"}, {role:"Dev", name:"Timur Isaev"}],
    mainImage:"/projects_images/woopra_bg.jpg",
    gallery: ['/projects_images/woopra/sm1.jpg', '/projects_images/woopra/sm2.jpg', '/projects_images/woopra/sm3.jpg'],
    timeDays:"50",
    timeHours:"420",
    url:"https://www.woopra.com/",
    body: `<div class="block">View your website recorded data in mobile app using data grids and charts</div>
                <div class="block">&nbsp;</div>
                <div class="description-title">Scope</div>
                <div class="block">Mobile app for Android and iOS with back-end API integration</div>
                <ul>
                    <li>Customer Journey reports
                    <li>Trends chart reports
                    <li>Retention reports
                    <li>Grid reports
                    <li>Users activity notifications
                </ul>
                <div class="block">&nbsp;</div>
                <div class="description-title">Tech stack</div>
                <div class="block">
                    Front-end: ReactNative and Redux + Bugsnag for QA
                    <p>Back-end: Node.js, Google Firebase, Auth0, Parse, FastLane/TestFlight
                </div>`,
    android:"",
    ios:"https://play.google.com/store/projects_images/details?id=com.nebeus.nebeus2",
  }
];



// WEBPACK FOOTER //
// ./src/projectsList.js